<script>
    import { onMount } from "svelte";
    import windows from "../../stores/windows.js";
    import isMobile from "../../helpers/mobile.js";

    export let window;

    let index = window.props.index || 0;
    let shouldArrangeWindow = true;

    const photos = window.props.photos;
    const totalPhotos = photos.length;

    function didChangeMouseWheel(e) {}

    function didClickPhoto() {
        if (totalPhotos <= 1) {
            return;
        }

        index = (index + 1) % totalPhotos;
    }

    function sizeToFit(image) {
        const maximumWidth = 600.0;
        const titleBarHeight = 40.0;
        const toolBarHeight = 64.0;

        if (image.width > image.height) {
            const width = Math.min(maximumWidth, innerWidth - titleBarHeight);

            return {
                width,
                height: width * (image.height / image.width) + toolBarHeight
            };
        }

        const height = Math.min(maximumWidth, innerHeight - titleBarHeight);
        let width = height * (image.width / image.height);

        if (width > innerWidth - titleBarHeight) {
            width = Math.min(maximumWidth, innerWidth - titleBarHeight);

            return {
                width,
                height: width * (image.height / image.width) + toolBarHeight
            };
        }

        return {
            width,
            height: height + toolBarHeight
        };
    }

    function moveToFit(width, height) {
        const existing = $windows.findLast(
            ({ id, kind, isClosed }) =>
                kind === "photo" && !isClosed && id !== window.id
        );

        if (existing) {
            return { x: existing.x + 20.0, y: existing.y + 20.0 };
        }

        return {
            x: (innerWidth - width) * 0.5,
            y: (innerHeight - height) * 0.5
        };
    }

    function didChangeIndex(e) {
        index = e.detail;
    }

    onMount(() => {
        const image = new Image();

        image.onload = () => {
            const { width, height } = sizeToFit(image);
            windows.resize(window.id, width, height);

            if (shouldArrangeWindow && !isMobile) {
                const { x, y } = moveToFit(width, height);
                windows.move(window.id, x, y);
            }

            shouldArrangeWindow = false;
        };

        image.src = window.props.photos[index].url;
    });
</script>

<svelte:window on:photo-index={didChangeIndex} />

<div class="photo" on:click={didClickPhoto}>
    <img
        src={window.props.photos[index].url}
        alt={window.props.photos[index].title}
        on:mousewheel={didChangeMouseWheel}
    />
</div>

<style>
    .photo {
        width: 100%;
        height: 100%;
        overflow: hidden;
        cursor: pointer;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
</style>
